import { render } from "./ProveedorCrear.vue?vue&type=template&id=1c521a26&scoped=true"
import script from "./ProveedorCrear.vue?vue&type=script&lang=js"
export * from "./ProveedorCrear.vue?vue&type=script&lang=js"

import "./ProveedorCrear.vue?vue&type=style&index=0&id=1c521a26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c521a26"]])

export default __exports__